// extracted by mini-css-extract-plugin
export default {"container":"RuleErrors_container__JsTyt","message":"RuleErrors_message__TSTzi","icon":"RuleErrors_icon__yLdEY","text":"RuleErrors_text__37BY3"};